import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import { SwivelpoleLogo } from "../icons";

const CalculatorAppBar = props => {
  let regionLabel;
  if (props.region) {
    regionLabel = <span style={{ textTransform: "uppercase" }}>({props.region})</span>;
  }
  return (
    <AppBar position="static" style={{ padding: "8px 24px" }}>
      <div className="AppBar">
        <Grid container spacing={24} alignItems="center">
          <Grid item xs={6}>
            <SwivelpoleLogo width="116" height="24" style={{ fill: "white" }} />
          </Grid>
          <Grid item xs={6}>
            <Typography style={{ color: "white" }} variant="h6" align="right">
              Cost Comparison Calculator {regionLabel}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </AppBar>
  );
};

export default CalculatorAppBar;
